/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Cancel_Reason_Rarely_UsedInputs */

const en_settings_cancel_reason_rarely_used = /** @type {(inputs: Settings_Cancel_Reason_Rarely_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I rarely use it`)
};

const id_settings_cancel_reason_rarely_used = /** @type {(inputs: Settings_Cancel_Reason_Rarely_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jarang kepakai`)
};

/**
* | output |
* | --- |
* | "I rarely use it" |
*
* @param {Settings_Cancel_Reason_Rarely_UsedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_cancel_reason_rarely_used = /** @type {((inputs?: Settings_Cancel_Reason_Rarely_UsedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Cancel_Reason_Rarely_UsedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_cancel_reason_rarely_used(inputs)
	return en_settings_cancel_reason_rarely_used(inputs)
});